import { MenuItem, Select } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	primaryBackground: {
		color: "white!important",
		backgroundColor: theme.palette.primary.main,
		border: `2px solid ${theme.palette.primary.main}`,
		borderRadius: "10px",
		"&:hover": {
			color: "white",
			backgroundColor: theme.palette.primary.dark,
			border: `2px solid ${theme.palette.primary.dark}`,
		},
		"&:disabled": {
			color: "white",
			backgroundColor: theme.palette.grey.main,
			border: `2px solid ${theme.palette.grey.main}`,
		},
	},
	primaryBorder: {
		color: theme.palette.primary.main,
		backgroundColor: "transparent",
		border: `2px solid ${theme.palette.primary.main}`,
		borderRadius: "10px",
		"&:hover": {
			color: theme.palette.primary.main,
			backgroundColor: theme.palette.grey.light,
			border: `2px solid ${theme.palette.primary.main}`,
		},
		"&:disabled": {
			color: "white",
			backgroundColor: theme.palette.grey.main,
			border: `2px solid ${theme.palette.grey.main}`,
		},
	},
	whiteIcon: {
		color: "white",
	},
	primaryIcon: {
		color: theme.palette.primary.main,
	},
}));

export const PrimaryBackgroundDropdown = ({
	id = "primary-background-dropdown",
	disabled = false,
	className = "",
	placeholder = "Placeholder",
	showPlaceholder = true,
	width = "150px",
	height = "40px",
	items = [],
	value,
	onChange,
}) => {
	const classes = useStyles();

	return (
		<Select
			key={id}
			id={id}
			value={value}
			disabled={disabled}
			displayEmpty={showPlaceholder}
			className={`${className} ${classes.primaryBackground}`}
			style={{ ...(width && { width }), ...(height && { height }) }}
			classes={{
				icon: classes.whiteIcon,
			}}
			autoWidth={!width}
			renderValue={(selected) => (selected || placeholder)}
			onChange={onChange}
		>
			{items.map((it) => (
				<MenuItem key={it.text} value={it.value}>{it.text}</MenuItem>
			))}
		</Select>
	);
};

export const PrimaryBorderDropdown = ({
	id = "primary-border-dropdown",
	disabled = false,
	className = "",
	placeholder = "Placeholder",
	showPlaceholder = true,
	width = "150px",
	height = "40px",
	items = [],
	value,
	onChange,
}) => {
	const classes = useStyles();

	return (
		<Select
			key={id}
			id={id}
			value={value}
			disabled={disabled}
			displayEmpty={showPlaceholder}
			className={`${className} ${classes.primaryBorder}`}
			style={{ ...(width && { width }), ...(height && { height }) }}
			classes={{
				icon: classes.primaryIcon,
			}}
			autoWidth={!width}
			renderValue={(selected) => (selected || placeholder)}
			onChange={onChange}
		>
			{items.map((it) => (
				<MenuItem key={it.text} value={it.value}>{it.text}</MenuItem>
			))}
		</Select>
	);
};
